"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const lodash_1 = require("lodash");
class Select extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.onChange = (event) => {
            const { onChange, options, reference } = this.props;
            const index = event.target.value;
            onChange(event, index, options[index], reference);
        };
    }
    render() {
        let _a = this.props, { className, selectSize, value, state, title, options, selectClassname, buttonClassname, disabled, customComponent, buttonSize } = _a, others = __rest(_a, ["className", "selectSize", "value", "state", "title", "options", "selectClassname", "buttonClassname", "disabled", "customComponent", "buttonSize"]);
        let classes = 'vf-dropdown';
        if (className)
            classes += ' ' + className;
        let selectClasses = 'vf-select has-dropdown';
        if (selectSize === 'sm')
            selectClasses += ' sm';
        if (selectClassname)
            selectClasses += ' ' + selectClassname;
        if (disabled)
            selectClasses += ' disabled';
        let buttonClasses = 'vf-btn hoverable vf-btn-default vf-btn--' + buttonSize;
        if (value === -1)
            buttonClasses += ' clean';
        if (state === 'error')
            buttonClasses += ' error';
        if (buttonClassname)
            buttonClasses += ' ' + buttonClassname;
        let optionList = lodash_1.map(options, (el, index) => {
            if (lodash_1.isPlainObject(el)) {
                let { render } = el, other = __rest(el, ["render"]);
                return (React.createElement("option", Object.assign({ key: index, value: index }, other), render));
            }
            return React.createElement("option", { key: index, value: index }, el);
        });
        return (React.createElement("div", { className: selectClasses },
            React.createElement("div", { className: classes }, this.props.customComponent ||
                React.createElement("button", { className: buttonClasses }, value === -1 ? title : options[value])),
            React.createElement("select", Object.assign({}, others, { onChange: this.onChange, value: value, disabled: disabled }),
                React.createElement("option", { disabled: true, value: -1 }, title),
                optionList)));
    }
}
Select.defaultProps = {
    value: -1,
    selectSize: 'md',
    buttonSize: 'sm'
};
exports.default = Select;
